export const promptDownloadFile = (url: any, fileName: any, newTab = true) => {
	if (!url || !fileName) {
		throw new TypeError('downloadFile: url and fileName are required');
	}

	if (typeof window === 'undefined') {
		throw new Error('downloadFile is not supported in server side');
	}

	const link = document.createElement('a');
	link.style.display = 'none';

	link.href = url;
	link.target = newTab ? '_blank' : '_self';

	link.download = fileName;

	document.body.appendChild(link);

	link.click();
};
